import React, { useEffect, useState, useRef } from "react";
import COLORS from "../../constants/colors";

function EiffelTowerGraphic() {
  return (
    <div
      style={{
        position: "relative",
        width: "180px",
        height: "260px",
        margin: "0 auto",
        transform: "translateY(8px)",
      }}
    >
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: "50%",
          width: "8px",
          height: "205px",
          background: "linear-gradient(180deg, #6C91BF 0%, #3B5068 100%)",
          transform: "translateX(-50%)",
          borderRadius: "999px",
          boxShadow: "0 0 18px rgba(108,145,191,0.25)",
        }}
      />

      <div
        style={{
          position: "absolute",
          bottom: "18px",
          left: "50%",
          width: "130px",
          height: "130px",
          borderLeft: "8px solid #4D657E",
          borderRight: "8px solid #4D657E",
          transform: "translateX(-50%) skewX(0deg)",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          clipPath: "polygon(50% 0%, 100% 100%, 0% 100%)",
          background: "linear-gradient(180deg, rgba(108,145,191,0.16), rgba(108,145,191,0.02))",
        }}
      />

      <div
        style={{
          position: "absolute",
          bottom: "90px",
          left: "50%",
          width: "100px",
          height: "70px",
          transform: "translateX(-50%)",
          borderLeft: "7px solid #5B7692",
          borderRight: "7px solid #5B7692",
          clipPath: "polygon(50% 0%, 100% 100%, 0% 100%)",
          background: "linear-gradient(180deg, rgba(108,145,191,0.22), rgba(108,145,191,0.03))",
        }}
      />

      <div
        style={{
          position: "absolute",
          bottom: "70px",
          left: "50%",
          width: "84px",
          height: "8px",
          background: "#698AAE",
          transform: "translateX(-50%)",
          borderRadius: "999px",
        }}
      />

      <div
        style={{
          position: "absolute",
          bottom: "145px",
          left: "50%",
          width: "60px",
          height: "45px",
          transform: "translateX(-50%)",
          borderLeft: "6px solid #698AAE",
          borderRight: "6px solid #698AAE",
          clipPath: "polygon(50% 0%, 100% 100%, 0% 100%)",
          background: "linear-gradient(180deg, rgba(108,145,191,0.26), rgba(108,145,191,0.04))",
        }}
      />

      <div
        style={{
          position: "absolute",
          bottom: "186px",
          left: "50%",
          width: "4px",
          height: "38px",
          background: "#4D657E",
          transform: "translateX(-50%)",
          borderRadius: "999px",
        }}
      />

      <div
        style={{
          position: "absolute",
          bottom: "222px",
          left: "50%",
          width: "12px",
          height: "12px",
          background: "#D4AF37",
          transform: "translateX(-50%) rotate(45deg)",
          boxShadow: "0 0 18px rgba(212,175,55,0.7)",
          borderRadius: "2px",
          animation: "towerSparkle 1.6s ease-in-out infinite",
        }}
      />

      <div
        style={{
          position: "absolute",
          bottom: "14px",
          left: "50%",
          width: "66px",
          height: "28px",
          transform: "translateX(-50%)",
          borderTop: "6px solid #4D657E",
          borderLeft: "6px solid #4D657E",
          borderRight: "6px solid #4D657E",
          borderTopLeftRadius: "40px",
          borderTopRightRadius: "40px",
          background: "transparent",
        }}
      />
    </div>
  );
}

export default function EntranceAnimation({ onFinish }) {
  const [hide, setHide] = useState(false);
  const hasPlayedRef = useRef(false); // 🔥 使用 useRef 记录是否已播放
  const ANIMATION_KEY = 'entrance_animation_shown'; //  添加存储键名

  useEffect(() => {
    // 🔥 检查 sessionStorage，确保整个会话期间只播放一次
    const hasPlayedInSession = sessionStorage.getItem(ANIMATION_KEY);
    
    // 如果已经在本次会话中播放过，或者 useRef 已标记，直接跳过
    if (hasPlayedInSession === "true" || hasPlayedRef.current) {
      // 立即调用 onFinish，不显示动画
      if (onFinish) {
        setTimeout(onFinish, 100); // 给一点延迟让组件卸载
      }
      return;
    }
    
    // 标记已播放（同时设置 useRef 和 sessionStorage）
    hasPlayedRef.current = true;
    sessionStorage.setItem(ANIMATION_KEY, "true");

    const t1 = setTimeout(() => setHide(true), 2600);
    const t2 = setTimeout(() => {
      if (onFinish) onFinish();
    }, 3300);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []); //  空依赖数组，只在第一次挂载时执行

  return (
    <>
      <style>
        {`
          @keyframes entranceFadeIn {
            0% { opacity: 0; transform: scale(1.03); }
            100% { opacity: 1; transform: scale(1); }
          }

          @keyframes entranceFadeOut {
            0% { opacity: 1; }
            100% { opacity: 0; }
          }

          @keyframes towerFloat {
            0% { transform: translateY(10px); }
            50% { transform: translateY(0px); }
            100% { transform: translateY(10px); }
          }

          @keyframes towerSparkle {
            0% { opacity: 0.45; transform: translateX(-50%) rotate(45deg) scale(0.9); }
            50% { opacity: 1; transform: translateX(-50%) rotate(45deg) scale(1.08); }
            100% { opacity: 0.45; transform: translateX(-50%) rotate(45deg) scale(0.9); }
          }

          @keyframes cloudMoveA {
            0% { transform: translateX(-14px); }
            50% { transform: translateX(10px); }
            100% { transform: translateX(-14px); }
          }

          @keyframes cloudMoveB {
            0% { transform: translateX(12px); }
            50% { transform: translateX(-10px); }
            100% { transform: translateX(12px); }
          }
        `}
      </style>

      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 10000,
          background: "linear-gradient(180deg, #F7F1E6 0%, #EEF4FB 55%, #F7F6F1 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: hide ? "entranceFadeOut 0.7s ease forwards" : "entranceFadeIn 0.8s ease",
        }}
      >
        <div
          style={{
            textAlign: "center",
            padding: "2rem",
            width: "100%",
            maxWidth: "560px",
          }}
        >
          <div
            style={{
              position: "relative",
              marginBottom: "1.4rem",
              animation: "towerFloat 3.2s ease-in-out infinite",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "20px",
                left: "26%",
                width: "70px",
                height: "24px",
                background: "rgba(255,255,255,0.65)",
                borderRadius: "999px",
                filter: "blur(0.3px)",
                animation: "cloudMoveA 6s ease-in-out infinite",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "54px",
                right: "24%",
                width: "84px",
                height: "28px",
                background: "rgba(255,255,255,0.68)",
                borderRadius: "999px",
                filter: "blur(0.3px)",
                animation: "cloudMoveB 7s ease-in-out infinite",
              }}
            />
            <EiffelTowerGraphic />
          </div>

          <div
            style={{
              fontSize: "2rem",
              fontWeight: 900,
              color: COLORS.text,
              letterSpacing: "0.02em",
            }}
          >
            Mon Paris Français
          </div>

          <div
            style={{
              marginTop: "0.7rem",
              color: COLORS.subtext,
              fontSize: "1rem",
              lineHeight: 1.8,
            }}
          >
            从巴黎铁塔启程，进入你的法语词汇之旅
          </div>

          <div
            style={{
              marginTop: "1rem",
              color: COLORS.blue,
              fontWeight: 700,
              fontStyle: "italic",
            }}
          >
            Bonjour et bienvenue.
          </div>
        </div>
      </div>
    </>
  );
}